import React from "react";
import { LegalLayout, H2, P, UL } from "./LegalLayout";

export default function TermsOfUse() {
  return (
    <LegalLayout
      testid="legal-terms-of-use"
      eyebrow="✦ HERITAGE BLOOM CLUB ✦"
      title="Website Terms of Use"
    >
      <H2 n="1">Acceptance Of Terms</H2>
      <P>Welcome to the Heritage Bloom Club website.</P>
      <P>
        By accessing, browsing or using this website, you agree to be bound by these Terms of
        Use and any other policies referenced on this website.
      </P>
      <P>If you do not agree with these Terms, you should discontinue use of the website.</P>

      <H2 n="2">About The Website</H2>
      <P>
        The Heritage Bloom Club website provides information, subscription services, grower
        applications, customer account functionality, educational content and related services.
      </P>
      <P>
        The content provided on this website is intended for general information and business
        purposes relating to the Heritage Bloom Club.
      </P>

      <H2 n="3">Website Access</H2>
      <P>We aim to keep the website available and functioning effectively at all times.</P>
      <P>However, we do not guarantee uninterrupted access and reserve the right to:</P>
      <UL>
        <li>Modify website functionality</li>
        <li>Update content</li>
        <li>Suspend services</li>
        <li>Perform maintenance</li>
        <li>Restrict access where necessary</li>
      </UL>
      <P>without prior notice.</P>

      <H2 n="4">User Accounts</H2>
      <P>Certain areas of the website may require account registration.</P>
      <P>Users are responsible for:</P>
      <UL>
        <li>Maintaining password confidentiality</li>
        <li>Protecting account access</li>
        <li>Ensuring information remains accurate</li>
        <li>Notifying Heritage of unauthorised account use</li>
      </UL>
      <P>Users are responsible for all activity occurring under their account credentials.</P>

      <H2 n="5">Acceptable Use</H2>
      <P>Users agree not to:</P>
      <UL>
        <li>Use the website unlawfully</li>
        <li>Interfere with website operation</li>
        <li>Attempt unauthorised access to systems</li>
        <li>Upload malicious software</li>
        <li>Collect information without permission</li>
        <li>Misrepresent identity</li>
        <li>Engage in fraudulent activity</li>
        <li>Use the website in any manner that may damage the Heritage Bloom Club brand or services</li>
      </UL>
      <P>We reserve the right to restrict access where misuse occurs.</P>

      <H2 n="6">Intellectual Property</H2>
      <P>Unless otherwise stated, all website content remains the property of Heritage Bloom Club or its licensors.</P>
      <P>This includes:</P>
      <UL>
        <li>Logos</li>
        <li>Branding</li>
        <li>Website design</li>
        <li>Graphics</li>
        <li>Images</li>
        <li>Written content</li>
        <li>Software systems</li>
        <li>Growers Portal technology</li>
        <li>Marketing materials</li>
      </UL>
      <P>Users may view and use website content for personal and lawful business purposes only.</P>
      <P>No content may be copied, reproduced, modified, distributed or commercially exploited without written permission.</P>

      <H2 n="7">Grower Content</H2>
      <P>
        Growers may provide photographs, farm information, biographies and other content for use
        within the Heritage Bloom Club platform.
      </P>
      <P>
        By providing such content, growers grant Heritage a non-exclusive licence to use,
        publish and promote that content for Bloom Club marketing, operational and promotional
        purposes.
      </P>
      <P>Ownership of grower content remains with the grower unless otherwise agreed.</P>

      <H2 n="8">Website Information</H2>
      <P>
        While reasonable care is taken to ensure information is accurate, Heritage Bloom Club
        makes no guarantee that all content is complete, current or error-free.
      </P>
      <P>
        Information provided on this website should not be relied upon as legal, financial,
        accounting or professional advice.
      </P>
      <P>Users should seek independent advice where appropriate.</P>

      <H2 n="9">External Links</H2>
      <P>This website may contain links to third-party websites.</P>
      <P>These links are provided for convenience only.</P>
      <P>
        Heritage Bloom Club does not control and is not responsible for the content, security or
        privacy practices of external websites.
      </P>
      <P>Accessing third-party websites is undertaken at the user's own risk.</P>

      <H2 n="10">Subscription Services</H2>
      <P>
        Where customers purchase Bloom Club subscriptions through the website, additional
        Subscription Terms &amp; Conditions apply.
      </P>
      <P>
        Where growers apply to join the Bloom Club, additional Grower Terms, Policies and
        Agreements may apply.
      </P>
      <P>These documents form part of the overall Heritage Bloom Club operating framework.</P>

      <H2 n="11">Limitation Of Liability</H2>
      <P>To the maximum extent permitted by law, Heritage Bloom Club shall not be liable for:</P>
      <UL>
        <li>Website interruptions</li>
        <li>Technical errors</li>
        <li>Data loss</li>
        <li>Viruses or malicious software</li>
        <li>Inaccuracies within website content</li>
        <li>Indirect or consequential loss arising from website use</li>
      </UL>
      <P>Users access and use the website at their own risk.</P>
      <P>
        Nothing in these Terms limits any rights that cannot legally be excluded under applicable
        consumer protection legislation.
      </P>

      <H2 n="12">Privacy</H2>
      <P>Use of this website is also governed by the Heritage Bloom Club Privacy Policy.</P>
      <P>
        By using this website, you acknowledge that personal information may be collected and
        handled in accordance with that policy.
      </P>

      <H2 n="13">Changes To These Terms</H2>
      <P>Heritage Bloom Club reserves the right to update these Terms of Use from time to time.</P>
      <P>Updated versions will be published on the website and become effective upon publication.</P>
      <P>Continued use of the website constitutes acceptance of any revised Terms.</P>

      <H2 n="14">Governing Law</H2>
      <P>These Terms of Use are governed by the laws of Aotearoa.</P>
      <P>Any disputes arising in connection with these Terms shall be subject to the jurisdiction of the Aotearoa courts.</P>

      <H2 n="15">Contact Information</H2>
      <UL>
        <li>Heritage Dahlias NZ Limited</li>
        <li>Email: <a href="mailto:heritagedahliasnz@gmail.com" className="text-[var(--berry-deep)] underline">heritagedahliasnz@gmail.com</a></li>
        <li>Website: <a href="https://heritagedahlias.nz" className="text-[var(--berry-deep)] underline">heritagedahlias.nz</a></li>
      </UL>

      <H2 n="16">Our Commitment</H2>
      <P>
        The Heritage Bloom Club exists to support local flower growers and strengthen local
        communities.
      </P>
      <P>
        We are committed to operating with transparency, professionalism and integrity while
        providing a secure and positive experience for all users of our website and services.
      </P>

      <H2 n="17">Intellectual Property Protection</H2>
      <P>
        The Heritage Bloom Club name, the Heritage Dahlias name, the Heritage seal mark, the
        stained-glass dahlia illustration set, all packaging artwork, all photography, the
        seasonal bloom-box concept, the subscriber waitlist system, the grower application
        portal, all written content, and all software powering this website are the
        intellectual property of <strong>Heritage Dahlias NZ Limited</strong>.
      </P>
      <P>
        These works are protected by copyright, trade-mark, registered and unregistered design
        rights under the Copyright Act 1994, the Trade Marks Act 2002, and the Fair Trading Act
        1986 of Aotearoa New Zealand, and under equivalent international treaty obligations.
      </P>
      <P>
        Any unauthorised reproduction, framing, scraping, training of machine-learning models,
        adaptation, distribution, commercial exploitation or imitation, including imitation of
        the visual identity, packaging or operating concept, constitutes infringement and may
        result in civil action.
      </P>
      <P>
        Users are granted a limited, non-exclusive, non-transferable and revocable licence to
        view the website and download images for personal, non-commercial reference only.
      </P>

      <H2 n="18">Subscriber Protection</H2>
      <P>
        The Heritage Bloom Club operates under the consumer-protection laws of Aotearoa New
        Zealand. As a website user and prospective subscriber you are protected by the
        following:
      </P>
      <UL>
        <li>Your personal information will never be sold or shared outside of the limited operational sharing described in our Privacy Policy</li>
        <li>Waitlist registration is free, non-binding and may be withdrawn at any time</li>
        <li>Any future paid subscription will be presented with clear pricing, frequency, region and cancellation rights prior to payment</li>
        <li>Refund, replacement and dispute pathways are set out in the Subscription Terms &amp; Conditions</li>
        <li>You retain all rights under the Consumer Guarantees Act 1993, Fair Trading Act 1986 and Privacy Act 2020</li>
      </UL>

      <H2 n="19">Grower Protection</H2>
      <P>
        Heritage Bloom Club protects participating growers through the Grower Terms &amp;
        Operating Framework, which guarantees fair payment, brand protection, intellectual
        property licensing, capacity control, confidentiality and a right of reply before any
        suspension or removal. Visitors to this website acknowledge that grower information
        published on this site is supplied with grower permission and is not to be scraped,
        republished or used for competing recruitment.
      </P>

      <H2 n="20">Insurance &amp; Operational Security</H2>
      <P>
        Heritage Dahlias NZ Limited carries commercial general liability and product liability
        insurance covering the operation of the Bloom Club platform and the supply of seasonal
        floral products through the Heritage brand. Participating growers carry their own
        insurance as required under the Grower Terms.
      </P>
      <P>
        Website infrastructure, subscriber data and grower data are hosted on insured,
        access-controlled cloud platforms. Payment information, where collected in the future,
        is processed through PCI-compliant third-party providers and is not stored on Heritage
        servers.
      </P>

      <P className="font-display-italic text-center text-[var(--berry-deep)] mt-10">
        Local Flowers. Local Growers. Local Communities.
      </P>
    </LegalLayout>
  );
}
